import * as AnalyticsService from "@brandclub/common-ui/analytics/AnalyticsService";

/**
 * The host's own Mixpanel SDK, adopted by this bundle.
 *
 * A host that owns analytics (the canonical Pages storefront) mounts this
 * bundle with `suppressAnalytics`, so the bundle starts NO SDK of its own and
 * publishes what survives that flag through the host's instance instead. The
 * host offers the instance at mount, but the two scripts load in an order
 * nobody controls: when this bundle mounts first, the instance arrives later,
 * through `adoptHostMixpanel` on the public API.
 *
 * Until an instance arrives there is no SDK to identify against, and a call
 * would throw inside Mixpanel. So the adoption is counted and published here,
 * and a component that needs identity subscribes and runs again when it lands.
 */
let adoptions = 0;
const listeners = new Set<() => void>();

/**
 * Publish through the host's SDK. Returns false when there is nothing to adopt,
 * or when this bundle already has an SDK — a second adoption would strand the
 * events the first one already sent.
 */
export function adoptHostMixpanel(instance: unknown): boolean {
  if (!instance) return false;
  if (AnalyticsService.isMixpanelInitialized()) return false;
  AnalyticsService.adoptMixpanelInstance(
    instance as Parameters<typeof AnalyticsService.adoptMixpanelInstance>[0]
  );
  adoptions += 1;
  listeners.forEach((listener) => listener());
  return true;
}

/** Tell me when an adoption happens. Returns the unsubscribe function. */
export function subscribeHostMixpanel(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** How many adoptions have happened. A snapshot for `useSyncExternalStore`. */
export function getHostMixpanelAdoptions(): number {
  return adoptions;
}
